// extracted by mini-css-extract-plugin
export default {"footer":"SiteFooter_footer__fnVXL","inner":"SiteFooter_inner__N65a2","brand":"SiteFooter_brand__hGy+J","links":"SiteFooter_links__P3GCD","legal":"SiteFooter_legal__f8+PS"};